import { addClassDuringActivity } from 'utilities/dom';
import { utagLinkAddRecommendedBulbs, utagLinkCart, utagLinkShowAddRecommendedBulbOption } from 'features/tealium/';
import { addCustomInfoToProductModel } from 'features/cart';
import updateUtagData from 'features/tealium/updateUtagData';
import { getCartDataFromUtag, trackCartUpdates } from 'features/monetate';
import { setGenericEvent } from 'features/tealium/ga4/custom';
import { trackAddToCartDy } from 'features/tealium/dynamicYield';

import { cart, cartModel } from '../config';
import CartBaseItemView from '../../baseViews/ItemView';
import { AddRecommendedBulb } from '../../api';
import AddRecommendedBulbsTemplate from '../templates/AddRecommendedBulbsTemplate';

const trackCartEvents = utagLinkCart();
const trackShowAddRecommendedBulbOption = utagLinkShowAddRecommendedBulbOption();
const AddRecommendedBulbs = CartBaseItemView.extend({
	JSXTemplate: AddRecommendedBulbsTemplate,
	ui: {
		bulbs: '#cartAddRecommendedBulbs',
		recommendedBulbReplacedMessage: '.recommendedBulbReplacedMessage'
	},
	events: {
		'click @ui.bulbs': 'addBulbs'
	},
	initialize () {

		const that = this;

		this.listenTo(this.model, 'change', this.render, this);

		// TODO: This element should have its own view
		// this is not in a view, so set listener normally
		$('.jsAddBulbs').on('click', (e) => {

			e.preventDefault();
			that.ui.bulbs.trigger('click', [ true ]);

		});

	},
	onRender () {

		// show/hide Add Bulbs icon in the cart header
		this.toggleAddBulbsIconInHeader();

		// Display message for IsRecommendedBulbReplaced if content is rendered
		const { recommendedBulbReplacedMessage } = this.ui;

		if (this.model.get('ShowAddRecommendedBulbOption')) {

			trackShowAddRecommendedBulbOption({
				eventAction: 'Load-Add Bulbs',
				nonInteraction: 1
			});
			setGenericEvent({
				event_name: 'cart_recbulbs_load'
			});

		}

		if (recommendedBulbReplacedMessage.length > 0) {

			$('body').lpModal({
				onInit: true,
				content: recommendedBulbReplacedMessage,
				height: 80,
				width: 425,
				appendContentToForm: false,
				openEvt () {

					$('.recommendedBulbReplacedMessage .dismiss').on('click', () => {

						$('body').lpModalClose();

					});

				}
			});

		}

	},
	onDomRefresh () {

		if (this.model.get('ShowAddRecommendedBulbOption')) {

			this.el.parentElement.classList.remove('hidden');

		} else {

			this.el.parentElement.classList.add('hidden');

		}

	},
	addBulbs (e, triggeredFromTopButton) {

		e.preventDefault();

		trackCartEvents({
			eventAction: '​Click-Add Bulbs',
			eventLabel: triggeredFromTopButton ? 'Top' : 'Bottom'
		});

		if (this.model.get('IsLedBulbsAvailable')) {

			this.sendAddBulbsRequest(true, triggeredFromTopButton);

		} else {

			this.sendAddBulbsRequest(false, triggeredFromTopButton);

		}

	},
	updateProductItemsBeforeCartUpdate (newProductItems) {

		const oldProductItems = cartModel.get('ProductItems');
		const extraNewItemCheck = (p) => p.BulbParentSkuId > 0;

		// No custom prop needed b/c we know it's always a recommended bulb with parent item
		// that's why data-is-recommended-bulb='1' attribute is hardcoded in the template in this instance
		const customPropNames = [];

		// eslint-disable-next-line no-param-reassign
		newProductItems = addCustomInfoToProductModel(
			oldProductItems,
			newProductItems,
			customPropNames,
			extraNewItemCheck
		);

	},
	rearrangeData (sequenceQueue, cartProductList) {

		cartProductList.sort((a, b) => {

			const aIndex = sequenceQueue.findIndex((item) => item.ShortSku === a.ShortSku && item.Id === a.Id);
			const bIndex = sequenceQueue.findIndex((item) => item.ShortSku === b.ShortSku && item.Id === b.Id);
			return aIndex - bIndex;

		});
		return cartProductList;

	},
	sendAddBulbsRequest (addLedBulbs, triggeredFromTopButton) {

		const that = this;
		const request = AddRecommendedBulb(addLedBulbs).then((response) => {

			// update the utag data to reflect the correct items
			updateUtagData(response.GlobalCartResponseModel.TealiumTagData);

			// Monetate AJAX update (retrack)
			trackCartUpdates(getCartDataFromUtag());

			utagLinkAddRecommendedBulbs(response);

			const recommendedBulbs = [];
			const productBulbItems = [];

			const fireSetGenericEvent = (cartAddedBulbInfo) => {

				setGenericEvent({
					event_name: 'cart_recbulbs_add',
					cart_addedbulb_info: cartAddedBulbInfo
				});

			};

			response.GlobalCartResponseModel.ProductItems.forEach((item) => {

				if (item.BulbParentSkuId > 0) {

					recommendedBulbs.push(item);

					const matchingItem = response.GlobalCartResponseModel.ProductItems.find(
						(recommendedProductBulb) => item.BulbParentSkuId === recommendedProductBulb.Id
					);

					const productBulbItem = matchingItem ? `${item.ShortSku}:${matchingItem.ShortSku}` : null;
					if (productBulbItem) productBulbItems.push(productBulbItem);

				}

			});

			if (window.top.DY) {

				try {

					recommendedBulbs.forEach((bulb) => {

						trackAddToCartDy(bulb.ShortSku, bulb.PriceSubTotal, bulb.Quantity);

					});

				} catch (e) {

					console.warn('DY API is not available', e);

				}

			}

			productBulbItems.forEach(fireSetGenericEvent);

			// Special logic for when new Recommended Bulbs are added, we need to capture SKUView event
			// with isRecommendeBulb=1 and hasAddToCart=1
			this.updateProductItemsBeforeCartUpdate(response.GlobalCartResponseModel.ProductItems);

			const newAddedSkuList = [];
			response.GlobalCartResponseModel.ProductItems.forEach((ele) => {

				newAddedSkuList.push({ ShortSku: ele.ShortSku, Id: ele.Id });

			});
			window.lp.sequenceQueue.addRecommendedBulbs(newAddedSkuList);
			response.GlobalCartResponseModel.ProductItems = this.rearrangeData(
				window.lp.sequenceQueue.getSequence(),
				response.GlobalCartResponseModel.ProductItems
			);

			cartModel.update(response);

			// show/hide Add Bulbs icon in the cart header
			that.toggleAddBulbsIconInHeader();

		});

		if (triggeredFromTopButton) {

			document
				.querySelectorAll('.jsAddBulbs')
				.forEach((el) => addClassDuringActivity(el, 'noPointerEvents', request));

		} else {

			addClassDuringActivity(this.ui.bulbs.get(0), 'loading noPointerEvents', request);

		}

		$(cart).trigger('indicateLoad', request);
		return request;

	},
	toggleAddBulbsIconInHeader () {

		if (this.model.get('ShowAddRecommendedBulbOption')) {

			$('.jsAddBulbsContainer').removeClass('hidden');

		} else {

			$('.jsAddBulbsContainer').addClass('hidden');

		}

	},
	showHelp (e) {

		$('body').lpModal({
			appendContentToForm: false,
			content: $('#cartHelpOverlay'),
			height: 320,
			onInit: true
		});
		e.preventDefault();

	}
});

export default AddRecommendedBulbs;
